<template>
    <main v-if="data && data.articles">
        <div class="heroCont">
            <h1 class="helvetica title1">News</h1>
            <div class="ctaCont">
                <a class="cta" href="">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.959 11.7203V19.0993H15.681V12.2143C15.681 10.4843 15.062 9.30434 13.514 9.30434C12.332 9.30434 11.628 10.1003 11.319 10.8693C11.206 11.1443 11.177 11.5273 11.177 11.9123V19.0993H6.897C6.897 19.0993 6.955 7.43934 6.897 6.23034H11.177V8.05434L11.149 8.09634H11.177V8.05434C11.745 7.17934 12.76 5.92834 15.033 5.92834C17.848 5.92834 19.959 7.76834 19.959 11.7203ZM2.421 0.0273438C0.958 0.0273438 0 0.987344 0 2.25034C0 3.48534 0.93 4.47434 2.365 4.47434H2.393C3.886 4.47434 4.813 3.48534 4.813 2.25034C4.787 0.987344 3.887 0.0273438 2.422 0.0273438H2.421ZM0.254 19.0993H4.532V6.23034H0.254V19.0993Z" fill="#283380" />
                    </svg>
                    <span class="line"></span>
                    <span class="baron headerText">follow eic</span>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.21967 9.78033C0.512563 10.0732 0.987437 10.0732 1.28033 9.78033L8.5 2.56066V8.25C8.5 8.66421 8.83579 9 9.25 9C9.66421 9 10 8.66421 10 8.25V0.75C10 0.335787 9.66421 0 9.25 0H1.75C1.33579 0 1 0.335787 1 0.75C1 1.16421 1.33579 1.5 1.75 1.5H7.43934L0.21967 8.71967C-0.0732233 9.01256 -0.0732233 9.48744 0.21967 9.78033Z" fill="#283380" />
                    </svg>
                </a>
            </div>
        </div>
        <div class="filters" v-if="(themeOptions && themeOptions.length > 0 || typeOptions && typeOptions.length > 0)">
            <NSelect v-if="themeOptions && themeOptions.length > 0" v-model:value="theme" placeholder="Themes" :options="themeOptions" size="large" :show-checkmark="false"></NSelect>
            <NSelect v-if="typeOptions && typeOptions.length > 0" v-model:value="type" placeholder="Types" :options="typeOptions" size="large" :show-checkmark="false"></NSelect>
        </div>
        <BlockGrid v-if="data && data.articles" :showTitle="false" :articles="data.articles.data" :meta="data.articles.meta" @update-page="pageUpdate" />
        <BottomPositionPapers />
        <WebsiteFooter />
    </main>
</template>

<script lang="ts" setup>
import { NSelect } from 'naive-ui';

const { getNewsPage } = usePages();
const route = useRoute()
const router = useRouter()

const theme = ref(route.query.theme as string | null)
const type = ref(route.query.type as string | null)

const { data } = useAsyncData('news-1', () => getNewsPage(1, theme.value, type.value), { watch: [theme, type] });

const themeOptions = computed(() => {
    if (data.value && data.value.themes) {
        return [
            { label: 'All themes', value: null },
            ...data.value.themes.map((theme: any) => {
                return {
                    label: theme.title,
                    value: theme.url
                }
            })
        ]
    } else return []
})
const typeOptions = computed(() => {
    if (data.value && data.value.types) {
        return [
            { label: 'All types', value: null },
            ...data.value.types.map((type: any) => {
                return {
                    label: type.label,
                    value: type.label
                }
            })
        ]
    } else return []
})

const pageUpdate = (newPage: number) => {
    if (newPage > 1) router.push({ path: `/news/p/${newPage}`, query: { theme: theme.value || undefined, type: type.value || undefined } })
    else router.push({ path: '/news', query: { theme: theme.value || undefined, type: type.value || undefined } })
}

watch(theme, () => {
    if (theme.value) router.replace({ query: { theme: theme.value, type: type.value || undefined } })
    else router.replace({ query: { theme: undefined, type: type.value || undefined } })
})
watch(type, () => {
    if (type.value) router.replace({ query: { theme: theme.value || undefined, type: type.value } })
    else router.replace({ query: { theme: theme.value || undefined, type: undefined } })
})

useSeoMeta({
    title: 'News | EIC Federation',
    ogTitle: 'News | EIC Federation',
    twitterTitle: 'News | EIC Federation',
})
</script>

<style lang="scss" scoped>
main {
    padding-top: var(--size-padding-header);

    .heroCont {
        margin: 0 var(--size-margin-page) var(--size-gutter-double) var(--size-margin-page);
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0 var(--size-margin-page);

        .ctaCont {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .cta {
                background-color: var(--color-secondary-light);
                padding: 12px 16px;

                color: var(--color-primary);
                text-decoration: none;

                display: flex;
                align-items: center;
                gap: 12px;

                transition: background-color 300ms 0ms cubic-bezier(.4, 0, .2, 1);

                .baron {
                    display: block;
                    margin-top: 5px;

                    font-size: 14px;
                    transition: color 300ms 0ms cubic-bezier(.4, 0, .2, 1);
                }

                .line {
                    display: block;
                    width: 1px;
                    height: 24px;
                    background-color: #C0D2D3;
                    transition: background-color 300ms 0ms cubic-bezier(.4, 0, .2, 1);
                }

                svg {
                    path {
                        fill: var(--color-primary);
                        transition: fill 300ms 0ms cubic-bezier(.4, 0, .2, 1);
                    }
                }

                &:hover {
                    background-color: var(--color-primary);
                    color: white;

                    .line {
                        background-color: white;
                    }

                    svg {
                        path {
                            fill: white;
                        }
                    }
                }
            }
        }
    }

    .filters {
        display: grid;
        grid-template-columns: repeat(8, minmax(0, 1fr));
        gap: var(--size-gutter-small);
        margin-bottom: var(--size-gutter-double);
        padding: 0 var(--size-margin-page);

        &:deep(.n-select) {

            .n-base-selection .n-base-selection-label {
                --n-color: white;
                --n-color-active: white;

                .n-base-selection-input,
                .n-base-selection-placeholder__inner {
                    color: var(--color-primary);
                }
            }

            .n-base-selection .n-base-selection__border,
            .n-base-selection .n-base-selection__state-border {
                --n-border: var(--size-thickness) solid var(--color-primary);
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    main {
        .filters {
            grid-template-columns: repeat(4, minmax(0, 1fr));
        }
    }
}

@media screen and (max-width: 600px) {
    main {
        .filters {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
}
</style>